__turbopack_context__.v({
  "callout-title": "_9HSSjq_callout-title",
  "card-title": "_9HSSjq_card-title",
  "code": "_9HSSjq_code",
  "code--accent": "_9HSSjq_code--accent",
  "code-row": "_9HSSjq_code-row",
  "codes": "_9HSSjq_codes",
  "disclaimer": "_9HSSjq_disclaimer",
  "eyebrow": "_9HSSjq_eyebrow",
  "hero-band": "_9HSSjq_hero-band",
  "hero-band--flush": "_9HSSjq_hero-band--flush",
  "hero-media": "_9HSSjq_hero-media",
  "page": "_9HSSjq_page",
  "page--flush": "_9HSSjq_page--flush",
  "price": "_9HSSjq_price",
  "price-card": "_9HSSjq_price-card",
  "price-copy": "_9HSSjq_price-copy",
});
